import { uniqueId } from 'lodash';
import checkInIcon from '../../images/links/ta/icn_checkin.png';
import workTimeTableIcon from '../../images/links/ta/icn_work_timetable.png';
import workTimeTableApproveIcon from '../../images/links/ta/icn_work_timetable_approval.png';
const module = 'TA';

export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_CheckIn',
    icon: checkInIcon,
    url: '/ta?id=webpunch',
    messageApi: null,
    sort: 3,
    functionCode: 'PunchCard',
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_PersonalWorkTimetable',
    icon: workTimeTableIcon,
    url: '/ta/personal/shiftschedule',
    messageApi: null,
    sort: 5,
    functionCode: 'PersonalShiftSchedule',
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_WorkTimetableForApproval',
    icon: workTimeTableApproveIcon,
    url: '/ta/supervisor/shiftscheduleapprovelist',
    messageApi: null,
    sort: 6,
    functionCode: ['SupervisorShiftScheduleApprovement', 'PersonalShiftScheduleApprovementSec'],
    funcCodeUrl: [
      {
        url: '/ta/supervisor/shiftscheduleapprovelist',
        functionCode: 'SupervisorShiftScheduleApprovement',
      },
      {
        url: '/ta/secretary/shiftscheduleapprovelist',
        functionCode: 'PersonalShiftScheduleApprovementSec',
      },
    ],
  },
];



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/config/links/ta.js
 **/